import * as animals from '@/assets/images/animals';

export default {
  model: 'image',
  cards: {
    a: { image: animals.a, vocal: 'animalsKid' },
    aa: { image: animals.aa, vocal: 'animalsKid' },
    b: { image: animals.b, vocal: 'animalsKid' },
    c: { image: animals.c, vocal: 'animalsKid' },
    cs: { image: animals.cs, vocal: 'animalsKid' },
    d: { image: animals.d, vocal: 'animalsKid' },
    dz: { image: animals.dz, vocal: 'animalsKid' },
    dzs: { image: animals.dzs, vocal: 'animalsKid' },
    e: { image: animals.e, vocal: 'animalsKid' },
    ee: { image: animals.ee, vocal: 'animalsKid' },
    f: { image: animals.f, vocal: 'animalsKid' },
    g: { image: animals.g, vocal: 'animalsKid' },
    gy: { image: animals.gy, vocal: 'animalsKid' },
    h: { image: animals.h, vocal: 'animalsKid' },
    i: { image: animals.i, vocal: 'animalsKid' },
    ii: { image: animals.ii, vocal: 'animalsKid' },
    j: { image: animals.j, vocal: 'animalsKid' },
    k: { image: animals.k, vocal: 'animalsKid' },
    l: { image: animals.l, vocal: 'animalsKid' },
    m: { image: animals.m, vocal: 'animalsKid' },
    n: { image: animals.n, vocal: 'animalsKid' },
    ny: { image: animals.ny, vocal: 'animalsKid' },
    o: { image: animals.o, vocal: 'animalsKid' },
    oo: { image: animals.oo, vocal: 'animalsKid' },
    ooo: { image: animals.ooo, vocal: 'animalsKid' },
    oooo: { image: animals.oooo, vocal: 'animalsKid' },
    p: { image: animals.p, vocal: 'animalsKid' },
    q: { image: animals.q, vocal: 'animalsKid' },
    r: { image: animals.r, vocal: 'animalsKid' },
    s: { image: animals.s, vocal: 'animalsKid' },
    sz: { image: animals.sz, vocal: 'animalsKid' }
  }
};
